module.exports = __webpack_public_path__ + "img/image4.d4ff1ec8.webp";